import { render } from "./WorkDialog.vue?vue&type=template&id=3945c87e"
import script from "./WorkDialog.vue?vue&type=script&lang=js"
export * from "./WorkDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__